"use client"

import { useState } from "react"
import { useRouter } from "next/navigation"
import { Button } from "@/components/ui/button"

export default function LoginPage() {
  const [key, setKey] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const router = useRouter()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError("")
    setLoading(true)

    try {
      const res = await fetch("/api/auth", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ key }),
      })

      if (res.ok) {
        router.push("/")
      } else {
        setError("Feil nøkkel")
      }
    } catch {
      setError("Kunne ikke koble til serveren")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <form
        onSubmit={handleSubmit}
        className="mx-auto w-full max-w-sm space-y-6 p-8"
      >
        <h1 className="text-center text-2xl font-bold text-foreground">
          BildeFortelliNger
        </h1>
        <div className="space-y-2">
          <label
            htmlFor="key"
            className="block text-sm font-medium text-muted-foreground"
          >
            Nøkkel
          </label>
          <input
            id="key"
            type="password"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            className="w-full rounded-md border border-input bg-background px-4 py-3 text-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="Skriv inn nøkkelen"
            autoFocus
          />
        </div>
        {error && (
          <p className="text-center text-sm text-destructive">{error}</p>
        )}
        <Button type="submit" className="w-full text-lg" disabled={loading}>
          {loading ? "Logger inn..." : "Logg inn"}
        </Button>
      </form>
    </div>
  )
}
